import axios from 'axios';

const API_URL = 'https://www.barcodepapel.pt:5017/api';

const getAuthHeader = () => {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

// Função para converter os dados para o formato esperado pelo backend
const formatParticipantData = (data) => {
  const formatted = {
    ...data,
    // Converter tipo para enum numérico
    type: data.type === 'Adult' ? 1 : 0, // 0 = Child, 1 = Adult
    // Serializar pessoas autorizadas como JSON string
    pessoasAutorizadas: data.pessoasAutorizadas && data.pessoasAutorizadas.length > 0
      ? data.pessoasAutorizadas  // ← Envia array diretamente
      : null
  };

  console.log('Dados formatados para enviar:', formatted);
  return formatted;
};

export const participantService = {
  getParticipants: async () => {
    try {
      const response = await axios.get(`${API_URL}/participants`, {
        headers: getAuthHeader()
      });
      return response.data;
    } catch (error) {
      console.error('Erro ao obter participantes:', error);
      throw error;
    }
  },

  getParticipantById: async (id) => {
    try {
      const response = await axios.get(`${API_URL}/participants/${id}`, {
        headers: getAuthHeader()
      });
      return response.data;
    } catch (error) {
      console.error('Erro ao obter participante:', error);
      throw error;
    }
  },

  createParticipant: async (participantData) => {
    try {
      const formattedData = formatParticipantData(participantData);
      const response = await axios.post(`${API_URL}/participants`, formattedData, {
        headers: getAuthHeader()
      });
      return response.data;
    } catch (error) {
      console.error('Erro ao criar participante:', error.response?.data || error.message);
      throw error;
    }
  },

  updateParticipant: async (id, participantData) => {
    try {
      const formattedData = formatParticipantData(participantData);
      console.log('Formatted data:', formattedData);
      const response = await axios.put(`${API_URL}/participants/${id}`, formattedData, {
        headers: getAuthHeader()
      });
      return response.data;
    } catch (error) {
      console.error('Erro ao atualizar participante:', error.response?.data || error.message);
      throw error;
    }
  },

  deleteParticipant: async (id) => {
    try {
      await axios.delete(`${API_URL}/participants/${id}`, {
        headers: getAuthHeader()
      });
    } catch (error) {
      console.error('Erro ao eliminar participante:', error);
      throw error;
    }
  }
};